import { Component, OnInit, SecurityContext } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../services/authentication.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfig } from 'src/assets/config/config/app-config';

@Component({
  selector: 'app-saml-login',
  templateUrl: './saml-login.component.html',
  styleUrls: ['./saml-login.component.scss']
})
export class SAMLLoginComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,    
    public router: Router,
    public sanitizer: DomSanitizer,
    private config: AppConfig
  ) { }

  ngOnInit() {
    this.login()
  }

  async login() {
    let userObj = null;
    userObj = localStorage.getItem('currentUser');
    let code = this.route.snapshot.queryParams['code'];
    let documentId = this.route.snapshot.queryParams['documentId'];
    let fileType = this.route.snapshot.queryParams['fileType'];    
    console.log(this.route, code);
    console.log(documentId);
    console.log(fileType);
    if (documentId) {
      localStorage.setItem('docId', documentId);
    }
    if (fileType) {
      localStorage.setItem('fileType', fileType);
    }
    if (code != undefined) {
      let body = {
        access_token: code
      }
      let res = null;
      try {
        console.log('Before making the GetToken call')
        res = await this.authenticationService.getToken(body).toPromise()
        console.log('After making the GetToken call')
      } catch (err) {
        if(err['error']['status_code'] === 500) {
          console.log(err)
          localStorage.clear();
          let auth_uri = this.config.getConfig("redirect_uri");
          window.location.href = auth_uri
          return;
        }
        console.log(err)
        localStorage.clear();
        // window.location.href = window.location.href.split('?')[0]
        alert('Unable to authorize user and fetch user details. Please contact your administrator')
        return;
      }
    
      if (res == null || res['token'] === null) {
        localStorage.clear();
        window.location.href = window.location.href.split('?')[0]
      }
      let currentUserObject = null;
      if (res != null) {
        currentUserObject = {
          username: res['username'],
          token: res['token']
        }
        localStorage.setItem("currentUser", JSON.stringify(currentUserObject));
        this.authenticationService.currentUserSubject.next(currentUserObject);
        localStorage.setItem('userGroups', JSON.stringify(res['groups']));
        let groups = res['groups']; 
        this.authenticationService.userGroupsSubject.next(groups);
        if (documentId == undefined || documentId == null || documentId === "") {
          documentId = localStorage.getItem('docId');
        }
        if (fileType == undefined || fileType == null || fileType === "") {
          fileType = localStorage.getItem('fileType');
        }      
        this.router.navigate(['/login-user'],
        { queryParams: { documentId: documentId, fileType: fileType, userName: res['username']} });        
      }
    } else {            
      let auth_uri = this.config.getConfig("redirect_uri");
      let redirect_uri = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(encodeURI(auth_uri)));
      window.location.href = redirect_uri;
    }
  }

}
